import register from '../register.js';

const deptStrToId = str => str.toLowerCase().replace( /\s+/g, '_' );

register( 'jobs-dropdown', () => {

  const dropdowns = {
    city: document.querySelector('.jobs-dropdown'),
    dept: document.querySelector('.departments-dropdown')
  };

  const labels = {
    city: dropdowns.city.querySelector('.dropdown__label'),
    dept: dropdowns.dept.querySelector('.dropdown__label')
  };

  const options = {
    city: dropdowns.city.querySelector('.dropdown__options'),
    dept: dropdowns.dept.querySelector('.dropdown__options')
  };

  const depts = document.querySelectorAll('.department');

  function hasNoChildren( dept ) {
    const visible = dept.querySelectorAll('li.job').length;
    const hidden = dept.querySelectorAll('li.job.hidden').length;

    return visible === hidden;
  }

  function showAllDepts() {
    depts.forEach( dept => dept.classList.remove('hidden') );
  }

  function doFilter() {
    const deptSelected = deptStrToId( labels.dept.innerText );
    const citySelected = labels.city.innerText;
    const allDepts     = deptSelected === 'all_departments';
    const allCities    = citySelected === 'All offices';

    const jobs = document.querySelectorAll('li.job');

    if ( allCities && allDepts ) {
      jobs.forEach( job => job.classList.remove('hidden') );
      showAllDepts();
      return;
    }

    jobs.forEach( job => {
      if ( citySelected === job.dataset.city || allCities ) {
        job.classList.remove('hidden');
      } else {
        job.classList.add('hidden');
      }
    });

    depts.forEach( dept => {
      let notSelectedDeptOrAll = ( dept.id !== deptSelected && !allDepts );
      let noChildren = hasNoChildren( dept );

      if ( notSelectedDeptOrAll || noChildren ) {
        dept.classList.add('hidden');
      } else {
        dept.classList.remove('hidden');
      }
    });
  }

  function registerDeptFilter() {
    options.dept.addEventListener( 'click', () => doFilter() );
  }

  function registerCityFilter() {
    options.city.addEventListener( 'click', () => doFilter() );
  }

  registerCityFilter();
  registerDeptFilter();

});

export default undefined;
